module.exports = __webpack_public_path__ + "img/banner2.151558aa.png";